import React from 'react';
import * as R from 'ramda';
import { makeStyles } from '@material-ui/core';

import {
  formatWeakestQuestionLabel,
  getWeakestQuestion,
} from 'resources/common/quizProgress/questionData';

const useStyles = makeStyles({
  link: {
    color: '#1565c0',
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:focus': {
      outline: '2px solid #1565c0',
      outlineOffset: 2,
    },
  },
});

const WeakestQuestionField = ({ record, onNavigate }) => {
  const classes = useStyles();
  const weakestQuestion = getWeakestQuestion(record);
  const label = formatWeakestQuestionLabel(weakestQuestion);

  if (!label) return <span>—</span>;

  const handleActivate = (event) => {
    event.stopPropagation();
    onNavigate(record, weakestQuestion.index);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleActivate(event);
    }
  };

  return (
    <span
      role="button"
      tabIndex={0}
      className={classes.link}
      onClick={handleActivate}
      onKeyDown={handleKeyDown}
    >
      {label}
    </span>
  );
};

WeakestQuestionField.defaultProps = {
  onNavigate: R.identity,
};

export default WeakestQuestionField;
